export const START_THEME_LOADING = 'START_THEME_LOADING';
export const STOP_THEME_LOADING = 'STOP_THEME_LOADING';

export const START_THEME_SUB_LOADING = 'START_THEME_SUB_LOADING';
export const STOP_THEME_SUB_LOADING = 'STOP_THEME_SUB_LOADING';

export const SUCCESS_GET_THEMES_LIST = 'SUCCESS_GET_THEMES_LIST';

export const RESET_THEME = 'RESET_THEME';
